import { StyleSheet } from '@react-pdf/renderer';

export const pdfSharedStyles = StyleSheet.create({
    test_border: {
        border: '1 solid #000',
    },
    page: {
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        fontSize: 10,
        fontFamily: 'DejaVuSans',
        paddingTop: 20,
        paddingBottom: 45,
        paddingLeft: 30,
        paddingRight: 30,
    },
    section: {
        marginBottom: 0,
    },
    innSection: {
        flexDirection: 'row',
        gap: 5,
        rowGap: 10,
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    colHalf: {
        width: '49%',
        borderColor: 'red',
        // borderWidth: 1,
    },
    spacer0: {
        height: 5,
    },
    spacer1: {
        height: 12,
    },
    spacer2: {
        height: 24,
    },
    spacer3: {
        height: 36,
    },
    title: {
        fontSize: 11,
        textAlign: 'left',
        // marginBottom: 20,
        fontWeight: 'bold',
    },
    resultTitle: {
        // color: '#004652',
        color: 'black',
        fontWeight: 'bold',
    },
    subTitle: {
        fontSize: 9,
        // marginBottom: 10,
        fontWeight: 'bold',
    },
    tableTitle: {
        fontSize: 10,
        // marginBottom: 5,
        // marginTop: 10,
        fontWeight: 'normal',
    },
    table: {
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderRightWidth: 0,
        borderBottomWidth: 0,
        // marginBottom: 10,
    },
    tableRow: {
        flexDirection: 'row',
    },
    oddRow: {
        backgroundColor: '#f2f2f2',
    },
    evenRow: {
        backgroundColor: '#fff',
    },
    tableColHeader: {
        width: '35%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: '#004652',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    // stile per PEDICE
    subscript: {
        fontSize: 6,
        verticalAlign: 'sub',
    },
    tableColHeaderSymbol: {
        width: '25%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: '#004652',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableColHeaderValue: {
        width: '20%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: '#004652',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableColHeaderUnit: {
        width: '20%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: '#004652',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableCol: {
        width: '35%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableColSymbol: {
        width: '25%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableColValue: {
        width: '20%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableColUnit: {
        width: '20%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableCellHeader: {
        fontSize: 9,
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#FFFFFF',
    },
    leftCell: {
        textAlign: 'left',
    },
    tableCell: {
        fontSize: 9,
        textAlign: 'center',
    },
    graphicSection: {
        marginTop: 0,
        // marginBottom: 8,
    },
    graphicImage: {
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
        //         borderStyle: 'solid',
        // borderWidth: 1,
        // borderColor: '#db0d0dff',
    },
    graphicImage_x3: {
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
        // flexWrap: 'wrap',
    },
    // chartImage: {
    //     width: '100%',
    //     height: 300,
    //     objectFit: 'contain',
    //     marginHorizontal: 'auto',
    // },
    chartImage: {
        marginHorizontal: 'auto',
        // marginTop: 10,
        width: '100%',
    },
    graphicDescription: {
        fontSize: 9,
        textAlign: 'center',
        // marginTop: 5,
        marginLeft: -23,
        color: '#555555',
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 9,
        bottom: 15,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
    graphicImagesContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
        // flexWrap: 'wrap',
    },
    projectInfoHeader: {
        // marginBottom: 20,
        borderStyle: 'solid',
        borderWidth: 0,
        borderColor: '#bfbfbf',
    },
    projectInfoHeaderTop: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        paddingTop: 0,
        paddingBottom: 12,
        paddingLeft: 0,
        paddingRight: 0,
        borderBottomWidth: 3,
        borderBottomColor: '#004652',
        borderBottomStyle: 'solid',
    },
    projectInfoLogo: {
        height: 25,
        width: 'auto',
        objectFit: 'contain',
    },
    projectInfoLeftSection: {
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'row',
        columnGap: 20,
    },
    projectInfoRightSection: {
        alignItems: 'flex-end',
        justifyContent: 'center',
        flexDirection: 'column',
        rowGap: 5,
    },
    projectInfoProjectType: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#000000',
    },
    pageNumberHeader: {
        fontSize: 9,
        color: 'black',
    },
    projectInfoSubtitle: {
        fontSize: 8,
        color: '#000000',
        // marginTop: 2,
        fontWeight: 'normal',
    },
    projectInfoTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        color: '#004652',
        padding: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#bfbfbf',
        borderBottomStyle: 'solid',
    },
    projectInfoContent: {
        flexDirection: 'row',
        minHeight: 200,
        width: '100%',
    },
    projectInfoTable: {
        width: '50%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderLeftColor: '#004652',
        borderLeftWidth: 3,
    },
    projectInfoRow: {
        flexDirection: 'row',
        borderStyle: 'solid',
        borderWidth: 0,
        borderColor: 'transparent',
        borderBottomWidth: 1,
        borderBottomColor: '#bfbfbf',
        borderBottomStyle: 'solid',
        borderRightWidth: 0,
    },
    projectInfoLabelCol: {
        width: '50%',
        backgroundColor: 'transparent',
        paddingLeft: 6,
        paddingBottom: 4,
        paddingTop: 4,
        borderRightWidth: 0,
        borderRightColor: '#bfbfbf',
        borderRightStyle: 'solid',
        justifyContent: 'center',
    },
    projectInfoValueCol: {
        width: '50%',
        padding: 6,
        backgroundColor: 'transparent',
        justifyContent: 'center',
    },
    projectInfoLabel: {
        fontSize: 8,
        fontWeight: 'normal',
    },
    projectInfoValue: {
        fontSize: 8,
    },
    projectInfoMapContainer: {
        width: '50%',
        padding: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    projectInfoMapImage: {
        width: '100%',
        maxHeight: 180,
        objectFit: 'contain',
    },
    projectInfoMapLabel: {
        fontSize: 8,
        textAlign: 'center',
        // marginTop: 4,
        color: '#666666',
    },
    projectInfoSubtitle2: {
        fontSize: 7,
        color: '#000000',
        // marginBottom: 2,
        fontWeight: 'normal',
    },
    projectInfoFooter: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 40,
        // backgroundColor: '#eee',
        textAlign: 'left',
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 30,
        paddingRight: 30,
        fontSize: 6,
        lineHeight: 1.2,
    },
    // Stili aggiuntivi per GeoGrid PDF
    dimFirstCol: {
        width: '60%', // Colonna più larga per descrizioni
    },
    // verifiedCol: {
    //     backgroundColor: '#e8f5e8', // Verde chiaro per verificato
    // },
    // notVerifiedCol: {
    //     backgroundColor: '#ffeaea', // Rosso chiaro per non verificato
    // },
    verifiedCol: {
        width: '100%',
        // backgroundColor: '#1ce67d',
        backgroundColor: '#92d050',
        color: '#000000',
        fontWeight: 'bold',
        textAlign: 'center',
        // paddingTop: '10',
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        alignItems: 'flex-end',
        flexDirection: 'row',
        paddingTop: 1,
        paddingBottom: 1,
    },
    notVerifiedCol: {
        width: '100%',
        // backgroundColor: '#1ce67d',
        backgroundColor: 'red',
        color: 'black',
        fontWeight: 'bold',
        textAlign: 'center',
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        alignItems: 'flex-end',
        flexDirection: 'row',
        paddingTop: 1,
        paddingBottom: 1,
    },
    verifiedColTableCell: {
        fontSize: 7,
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    statusMessageCell: {
        fontSize: 7,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textAlign: 'left',
        paddingLeft: 10,
    },
    graphicImageContainer: {
        alignItems: 'center',
        width: '45%',
    },
    // Stili specifici per tabelle GeoGrid
    tableColHeaderGeogrid: {
        width: '40%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: '#004652',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    tableColGeogrid: {
        width: '40%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        justifyContent: 'center',
    },
    geogridGraphicImage: {
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
        // marginBottom: 10,
    },

    // Container Yard PDF styles
    imageContainer: {
        width: '45%',
        alignItems: 'center',
        marginBottom: 15,
    },
    imageCaption: {
        fontSize: 9,
        textAlign: 'center',
        marginBottom: 5,
        fontWeight: 'bold',
    },
    image: {
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
    },
    // Chart-specific styles for better visibility
    chartContainer: {
        width: '100%',
        alignItems: 'center',
        marginBottom: 15,
        marginTop: 10,
    },
    chartCaption: {
        fontSize: 10,
        textAlign: 'center',
        marginBottom: 8,
        fontWeight: 'bold',
        color: '#004652',
    },
});
